import { create } from 'zustand';
import { api } from '../services/api';

export const useAuthStore = create((set) => ({
  user: null,
  token: localStorage.getItem('token') || null,
  loading: false,
  error: null,

  // Load user profile from API
  loadProfile: async () => {
    try {
      const response = await api.getProfile();
      set({ user: response.data, loading: false });
      return response.data;
    } catch (error) {
      console.error('Failed to load profile:', error);
      set({ user: null, token: null, loading: false });
      localStorage.removeItem('token');
    }
  },

  login: async (email, password) => {
    set({ loading: true, error: null });
    try {
      const response = await api.login({ email, password });
      const { customer, token } = response.data;
      localStorage.setItem('token', token);
      set({ user: customer, token, loading: false });
      return customer;
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Login failed';
      set({ error: errorMsg, loading: false });
      throw error;
    }
  },

  register: async (data) => {
    set({ loading: true, error: null });
    try {
      const response = await api.register(data);
      const { customer, token } = response.data;
      localStorage.setItem('token', token);
      set({ user: customer, token, loading: false });
      return customer;
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Registration failed';
      set({ error: errorMsg, loading: false });
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    set({ user: null, token: null });
  },

  setUser: (user) => set({ user }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),
}));
